export default class Setting {
    constructor(dto) {
        // Regional Settings
        this.defaultDateFormat = '';
        this.defaultDecimalSeparator = '';
        this.defaultThousandSeparator = '';
        this.defaultLanguageId = '';
        this.defaultTimezone = '';

        // Security
        this.enablePasswordExpiration = false;
        this.passwordExpirationDays = '';
        this.enableAccountInactivity = false;
        this.accountInactivityDays = '';
        this.enableFailedLoginAttempts = false;
        this.failedLoginAttempts = '';
        this.enableTokenExpiration = true;
        this.tokenExpirationMinutes = '';
        this.enablePasswordStrength = false;
        this.passwordStrengthMinLength = '';
        this.passwordStrengthMaxLength = '';
        this.passwordStrengthSpecialLength = '';
        this.passwordStrengthUpperLength = '';
        this.passwordStrengthNumberLength = '';
        this.enableMaxDaysToUnblockObjects = false;
        this.maxDaysToUnblockObjects = 0;

        // Search
        this.searchResultsOrderAsc = false;
        this.searchResultsVisibleFields = 0;
        this.searchResultsVisibleTableFields = 0;
        this.maxSearchResults = 0;
        this.enableDocumentPreAuthorization = false;

        //DocuSign
        this.docuSignEnabled = false;
        this.docuSignAccountID = '';
        this.docuSignApiURL = '';
        this.docuSignIntegrationKey = '';
        this.docuSignRSAKey = '';

        // SAML
        this.samlCertificate = '';
        this.samlEndpoint = '';

        // Document Intelligence Providers
        this.documentIntelligenceParameters = [];

        // Two-Factor Authentication
        this.twoFactorAuthenticationServiceId = '';
        this.twoFactorAuthenticationAuthApiKey = '';

        if (dto) {
            // Regional Settings
            this.defaultDateFormat = dto.DefaultDateFormat;
            this.defaultDecimalSeparator = dto.DefaultDecimalSeparator;
            this.defaultThousandSeparator = dto.DefaultThousandSeparator;
            this.defaultLanguageId = dto.DefaultLanguageID + '';
            this.defaultTimezone = dto.DefaultTimezone;

            // Security
            this.enablePasswordExpiration = dto.EnablePasswordExpiration;
            if (dto.EnablePasswordExpiration) {
                this.passwordExpirationDays = dto.PasswordExpirationDays;
            }
            this.enableMaxDaysToUnblockObjects = dto.EnableMaxDaysToUnblockObjects;
            if (dto.EnableMaxDaysToUnblockObjects) {
                this.maxDaysToUnblockObjects = dto.MaxDaysToUnblockObjects;
            }
            this.enableAccountInactivity = dto.EnableAccountInactivity;
            if (dto.EnableAccountInactivity) {
                this.accountInactivityDays = dto.AccountInactivityDays;
            }
            this.enableFailedLoginAttempts = dto.EnableFailedLoginAttempts;
            if (dto.EnableFailedLoginAttempts) {
                this.failedLoginAttempts = dto.FailedLoginAttempts;
            }
            this.tokenExpirationMinutes = dto.TokenExpirationMinutes;
            this.enablePasswordStrength = dto.EnablePasswordStrength;
            if (dto.EnablePasswordStrength) {
                this.passwordStrengthMinLength = dto.PasswordStrengthMinLength;
                this.passwordStrengthMaxLength = dto.PasswordStrengthMaxLength;
                this.passwordStrengthSpecialLength = dto.PasswordStrengthSpecialLength;
                this.passwordStrengthUpperLength = dto.PasswordStrengthUpperLength;
                this.passwordStrengthNumberLength = dto.PasswordStrengthNumberLength;
            }

            // Search
            this.searchResultsOrderAsc = dto.SearchResultsOrderAsc;
            this.searchResultsVisibleFields = dto.SearchResultsVisibleFields;
            this.searchResultsVisibleTableFields = dto.SearchResultsVisibleTableFields;
            this.maxSearchResults = dto.MaxSearchResults;
            this.enableDocumentPreAuthorization = dto.EnableDocumentPreAuthorization;

            // DocuSign
            this.docuSignAccountID = dto.DocuSignAccountID;
            this.docuSignApiURL = dto.DocuSignApiURL;
            this.docuSignIntegrationKey = dto.DocuSignIntegrationKey;
            this.docuSignRSAKey = dto.DocuSignRSAKey;
            this.docuSignEnabled = (this.docuSignAccountID && this.docuSignApiURL && this.docuSignIntegrationKey && this.docuSignRSAKey);

            // SAML
            this.samlCertificate = dto.SAMLCertificate;
            this.samlEndpoint = dto.SAMLEndpoint;

            // Document Intelligence Providers
            this.documentIntelligenceParameters = dto.DocumentIntelligenceParameters;

            this.twoFactorAuthenticationServiceId = dto.TwoFactorAuthenticationServiceId;
            this.twoFactorAuthenticationAuthApiKey = dto.TwoFactorAuthenticationAuthApiKey;
        }
    }

    toDto() {
        return {
            // Regional Settings
            DefaultDateFormat: this.defaultDateFormat,
            DefaultDecimalSeparator: this.defaultDecimalSeparator,
            DefaultThousandSeparator: this.defaultThousandSeparator,
            DefaultLanguageID: this.defaultLanguageId,
            DefaultTimezone: this.defaultTimezone,

            // Security
            EnablePasswordExpiration: this.enablePasswordExpiration,
            PasswordExpirationDays: this.passwordExpirationDays,
            EnableAccountInactivity: this.enableAccountInactivity,
            AccountInactivityDays: this.accountInactivityDays,
            EnableFailedLoginAttempts: this.enableFailedLoginAttempts,
            FailedLoginAttempts: this.failedLoginAttempts,
            EnableTokenExpiration: this.enableTokenExpiration,
            TokenExpirationMinutes: this.tokenExpirationMinutes,
            EnablePasswordStrength: this.enablePasswordStrength,
            PasswordStrengthMinLength: this.passwordStrengthMinLength,
            PasswordStrengthMaxLength: this.passwordStrengthMaxLength,
            PasswordStrengthSpecialLength: this.passwordStrengthSpecialLength,
            PasswordStrengthUpperLength: this.passwordStrengthUpperLength,
            PasswordStrengthNumberLength: this.passwordStrengthNumberLength,
            EnableMaxDaysToUnblockObjects: this.enableMaxDaysToUnblockObjects,
            MaxDaysToUnblockObjects: this.maxDaysToUnblockObjects,

            // Search
            MaxSearchResults: this.maxSearchResults,
            SearchResultsOrderAsc: this.searchResultsOrderAsc,
            SearchResultsVisibleFields: this.searchResultsVisibleFields,
            SearchResultsVisibleTableFields: this.searchResultsVisibleTableFields,
            EnableDocumentPreAuthorization: this.enableDocumentPreAuthorization,

            //DocuSign
            DocuSignAccountID: (this.docuSignEnabled ? this.docuSignAccountID : ''),
            DocuSignApiURL: (this.docuSignEnabled ? this.docuSignApiURL : ''),
            DocuSignIntegrationKey: (this.docuSignEnabled ? this.docuSignIntegrationKey : ''),
            DocuSignRSAKey: (this.docuSignEnabled ? this.docuSignRSAKey : ''),

            // SAML
            SAMLCertificate: this.samlCertificate,
            SAMLEndpoint: this.samlEndpoint,

            // Document Intelligence Providers
            DocumentIntelligenceParameters: this.documentIntelligenceParameters,

            // Two-Factor Authentication
            TwoFactorAuthenticationServiceId: this.twoFactorAuthenticationServiceId,
            TwoFactorAuthenticationAuthApiKey: this.twoFactorAuthenticationAuthApiKey
        };
    }
}
